import React from 'react';
import { Alert, Input, Button } from 'antd';
import { assoc } from 'ramda';
import { MailOutlined } from '@ant-design/icons';
import AccountLayout from '../../layout/account/AccountLayout';
import { emailIsValid } from '../../lib/validation';
import usePassword from '../../hooks/usePassword';

const RequestPassword = () => {
  const {
    loading,
    email,
    sent,
    setState,
    onRequestPassword
  } = usePassword();

  return (
    <AccountLayout>
      <h3>Réinitialiser votre mot de passe</h3>

      {!sent && (
        <>
          <Input
            prefix={<MailOutlined/>}
            placeholder="E-mail"
            size="middle"
            onChange={e => setState(assoc('email', e.target.value))}
          />

          <br/>

          <Button
            type="primary"
            htmlType="submit"
            disabled={!emailIsValid(email)}
            loading={loading}
            onClick={onRequestPassword}
            size="large"
            className="mt-4"
          >
            Envoyer
          </Button>
        </>
      )}

      {sent && (
        <div>
          <Alert
            type="success"
            message={<span>{'Un email vient de vous être envoyé à l\'adresse'}&nbsp;<b>{email}</b>&nbsp;avec un lien pour changer votre mot de passe</span>}
          />
          <br/>
          <Button
            size="large"
            onClick={() => setState(assoc('sent', false))}
            type="primary"
          >
            {'Je n\'ai pas reçu le mail'}
          </Button>
        </div>
      )}
    </AccountLayout>
  );
};

export default RequestPassword;
